import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { NotificacoesEnviadasColumns } from './columns/_columns'
import { NotificacaoAdminList } from '../../core/_models'

export const NotificacoesEnviadasTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma notificação encontrada'
      description='Revise o destinatário, o título, a categoria ou o push.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma notificação enviada ainda'
      description='As notificações enviadas aos usuários aparecem aqui.'
    />
  )

  return (
    <CustomTable<NotificacaoAdminList>
      id='kt_table_notificacoes_enviadas'
      ariaLabel='Notificações enviadas'
      itemLabel={{ singular: 'notificação', plural: 'notificações' }}
      data={response?.data || []}
      columns={NotificacoesEnviadasColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
